import { useState, useEffect } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import { Link } from 'react-router-dom'

import * as notificacionesService from '../servicios/notificacionesService'
import './Dropdown.css'

const NOTIFICATION_MAX_LENGTH = 35

const DropdownNotificacion = () => {
  const [notificaciones, setNotificaciones] = useState([])
  const [notificacionExistente, setNotificacionExistente] = useState(false)
  const idUsuarioChat = parseInt(localStorage.getItem('idUsuario'))

  const fetchNotificaciones = async () => {
    const { data } = await notificacionesService.buscarPorMensaje(idUsuarioChat)
    setNotificaciones(data)
    if (data.length !== 0) {
      setNotificacionExistente(true)
    }
  }

  useEffect(() => {
    fetchNotificaciones()
  }, [])

  const handleClickNotificacion = async (idMensaje) => {
    await notificacionesService.actualizarNotificacion({
      idMensaje: idMensaje
    })
    contador(idMensaje)
  }

  const obtenerURL = (
    tipoNotificacion,
    idPresupuesto,
    idPublicacion,
    idPedidoItem,
    idVendedor
  ) => {
    let path

    switch (tipoNotificacion) {
      case 'PRESUPUESTO':
        path = `/Presupuesto/${idPresupuesto}`
        break

      case 'PUBLICACION':
        path = `/${
          idVendedor === idUsuarioChat ? 'PreguntasVendedor' : 'PreguntasComprador'
        }/${idPublicacion}/${idVendedor}`

        break
      default:
        path = `/Pedidos/${idPedidoItem}`
    }
    return path
  }

  const contador = (idMensaje) => {
    setNotificaciones((prevNotificaciones) =>
      prevNotificaciones.map((notificacion) =>
        notificacion.idMensaje === idMensaje
          ? { ...notificacion, fechaLeido: 'leido' }
          : { ...notificacion }
      )
    )
  }

  return (
    <>
      <Dropdown id={'drop-mobile-style'}>
        <Dropdown.Toggle id="drop-toggle-style">
          <div className="btn btn-notificaciones">
            <span className={'fa fa-bell mr-1'}></span>
            <span className="badge badge-light">
              {notificaciones.filter((n) => n.fechaLeido === null).length}
            </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
          className={
            notificacionExistente
              ? 'dropdown-link-notificacion'
              : 'contenedor-notificaciones-vacias'
          }
        >
          {notificacionExistente ? (
            notificaciones.map((notificacion) => (
              <Dropdown.Item
                as={Link}
                to={obtenerURL(
                  notificacion.tipoNotificacion,
                  notificacion.idPresupuesto,
                  notificacion.idPublicacion,
                  notificacion.idPedidoItem,
                  notificacion.idVendedor
                )}
                key={notificacion.idMensaje}
                onClick={() =>
                  handleClickNotificacion(notificacion.idMensaje, notificacion.fechaLeido)
                }
                className={`estilo ${
                  notificacion.fechaLeido === null
                    ? 'fa fa-circle circulo'
                    : 'circulo-vacio'
                }`}
              >
                <div className="notificacion-nueva">
                  {notificacion.mensajeSistema} en{' '}
                  <b className="titulo-notificacion-publicacion">{notificacion.titulo}</b>
                  <div className="texto-notificacion">
                    {notificacion.texto}
                    {notificacion.texto.length === NOTIFICATION_MAX_LENGTH ? '...' : ''}
                  </div>
                </div>
              </Dropdown.Item>
            ))
          ) : (
            <div className="notificaciones-vacias">Aún no tienes notificaciones.</div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  )
}

export default DropdownNotificacion
